var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAssetHexagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 204",
    d: "M18.6877 1.24414H9.3798C7.98894 1.24414 6.69793 1.96663 5.97049 3.1521L1.27098 10.8107C0.490072 12.0833 0.482969 13.685 1.25256 14.9645L5.97542 22.8166C6.69883 24.0193 7.99965 24.7548 9.40316 24.7548H18.6644C20.0751 24.7548 21.3814 24.0118 22.1024 22.7993L26.772 14.9471C27.5277 13.6762 27.5207 12.092 26.7538 10.8278L22.1076 3.16939C21.3824 1.97409 20.0858 1.24414 18.6877 1.24414Z",
    fill: "#FDFDFD",
    stroke: "url(#paint0_linear_22394_203606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22394_203606",
    x1: 0,
    y1: 1.24414,
    x2: -11.3458,
    y2: 46.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAssetHexagon);
export default __webpack_public_path__ + "static/media/critical_asset_hexagon.4bd9020d7e6498cab5ee44d60f216bcb.svg";
export { ForwardRef as ReactComponent };